"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var Accordion = /** @class */ (function () {
    function Accordion(dropdownMenu, handlerClass, parentClass) {
        if (handlerClass === void 0) { handlerClass = 'accordion-toggler'; }
        if (parentClass === void 0) { parentClass = 'accordion'; }
        this.dropdownMenu = dropdownMenu;
        this.handlerClass = handlerClass;
        this.parentClass = parentClass;
    }
    Accordion.prototype.initListeners = function () {
        var _this = this;
        var handles = this.dropdownMenu.querySelectorAll('.' + this.handlerClass);
        var _loop_1 = function (i) {
            var handle = handles[i];
            handle.addEventListener('click', function (e) {
                e.preventDefault();
                _this.toggle(handle);
            });
        };
        for (var i = 0; i < handles.length; i++) {
            _loop_1(i);
        }
    };
    Accordion.prototype.closeAllAccordions = function (link) {
        var openAccordions = document.querySelectorAll(".".concat(this.parentClass, " .").concat(Accordion.OPEN_CLASS));
        for (var i = 0; i < openAccordions.length; i++) {
            openAccordions[i].classList.remove(Accordion.OPEN_CLASS);
        }
    };
    Accordion.prototype.open = function (element) {
        element.classList.add(Accordion.OPEN_CLASS);
    };
    Accordion.prototype.close = function (element) {
        element.classList.remove(Accordion.OPEN_CLASS);
    };
    Accordion.prototype.toggle = function (handle) {
        this.closeAllAccordions();
        if (handle.parentElement.classList.contains(Accordion.OPEN_CLASS)) {
            this.close(handle.parentElement);
        }
        else {
            this.open(handle.parentElement);
        }
    };
    Accordion.OPEN_CLASS = 'open';
    return Accordion;
}());
exports.Accordion = Accordion;
